<!-- https://xd.adobe.com/view/d78cbc0b-fa27-47d4-9328-317ef5da0e00-82df/
https://xd.adobe.com/view/d78cbc0b-fa27-47d4-9328-317ef5da0e00-82df/screen/97a0aef0-8869-467c-bf73-a1bb355d738e/
https://xd.adobe.com/view/931e04ab-d30f-4c7e-abd4-00475c4f6920-c64d/
https://docs.google.com/presentation/d/1CxM-NFQZ50lvdVmAnYNfjG_YXh527wnnejMM7weRjAs/edit#slide=id.p
-->
<template>
  <div id="mangellist" class="clearfix px3 notosans darkblue">
      <div class="mt2 my3">
            <p class="h3 col-12 line-height-golden bold p0">Mangel-liste</p>
      </div>
      <div class="flex col-12 p0 mobile-flex-column">
      <p class="h3 line-height-golden">Renoverer mit hus for at gøre det nyt og fantastisk</p>
      <div class="clearfix mb2 flex flex-wrap ml-auto items-center xs-gap-10 gap-20">
        <p class="m0 h5 regular xs-col-12">End Date:</p>
        <el-date-picker v-model="deadline" @change="changeenddate()" :disabled="isPreApprove" size="large" format="yyyy/MM/dd" value-format="yyyy-MM-dd" type="date" placeholder="start" :picker-options="pickerOptions" class="px0 primarycolor"></el-date-picker>
        <button type="button" @click="openincompleteModal()" :disabled="isPreApprove" class="dark-button flex items-center px2 py1 rounded">
          <span class=""><i class="white h5 m0 el-icon-circle-plus-outline"></i></span>
          <span class="pl2 regular white">ADD LIST</span>
        </button>
      </div> 
      </div>
      <div class="col-12" v-if="loading">
        <Loading></Loading>
      </div>
      <div class="flex flex-column " v-else>
        <div v-if="getDefiencyList.length > 0">
          <div class="p2 flex flex-column border primar-border rounded mb2 relative" :class="list.checked ? 'opacity-50 ' : ' ' " v-for="(list,index) in getDefiencyList" :key="index">
            <div class="col-12 flex p0 z4" v-if="isPreApprove">
              <p class="m0 p0 darklue semi-bold">{{list.TITLE}}</p>
              <div class="ml-auto relative lg-col-2 md-col-2 xs-col-5">
                <span class="absolute top-0" style="top:-10px;"> Marker som færdig</span>
                <el-checkbox v-model="list.checked" :disabled="list.checked" class="absolute" style="top:20px;left: 70px;" @change="markasdone(list.ID, index)"></el-checkbox>
              </div>
            </div>
            <div class="flex col-12 p0 m0 gap-10 z1" v-if="list.IMAGES.length > 0">
              <img :src="image.IMAGE_LINK" v-for="(image,index) in list.IMAGES" :key="index" @click="opengallery(list.IMAGES)" @error="checkimage(index)" :id="'imagedivreview' + index" width="60px" height="60px" class="rounded cover pointer" alt="defiency images">
            </div>
            <div class="col-12 py2 p0 z1">
              <p class="regular h6 p0">{{list.DESCRIPTION}}</p>
            </div>
            <div class="flex col-12 p0 m0 z1">
              <div>
                <p class="tagitem m0">{{list.INDUSTRY}}</p>
              </div>
              <div class="ml-auto flex justify-center items-center" v-if="!isPreApprove">
                <el-tooltip content="View Comment" placement="top">
                    <span class="px2" @click="viewComment(list.ID)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32.001" height="33.416" viewBox="0 0 32.001 33.416">
                        <path id="comment" d="M32.985,6A3,3,0,0,0,30,3H6A3.009,3.009,0,0,0,3,6V24a3.009,3.009,0,0,0,3,3H27l6,6Z" transform="translate(-2 -2)" fill="none" stroke="#003645" stroke-width="2"/>
                      </svg>
                    </span>
                </el-tooltip>
                <el-tooltip content="Edit" placement="top">
                  <span class="px2" @click="SelectDefiencyItem(list)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32.182" height="32.182" viewBox="0 0 32.182 32.182">
                      <g id="edit" transform="translate(1 1)">
                        <path id="Path_4681" data-name="Path 4681" d="M16.5,6H6A3,3,0,0,0,3,9V30a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3V19.5" transform="translate(-3 -2.818)" fill="none" stroke="#003645" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <path id="Path_4682" data-name="Path 4682" d="M27.75,3.75a3.182,3.182,0,0,1,4.5,4.5L18,22.5,12,24l1.5-6Z" transform="translate(-3 -2.818)" fill="none" stroke="#003645" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                      </g>
                    </svg>
                  </span>
                </el-tooltip>
                <el-tooltip content="Delete" placement="top">
                  <span class="px2" @click="deleteDeficiency(list.ID)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="32" viewBox="0 0 29 32">
                      <g id="delete" transform="translate(-3.5 -2)">
                        <path id="Path_4683" data-name="Path 4683" d="M4.5,9h27" fill="none" stroke="#003645" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <path id="Path_4684" data-name="Path 4684" d="M28.5,9V30a3,3,0,0,1-3,3h-15a3,3,0,0,1-3-3V9M12,9V6a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3V9" fill="none" stroke="#003645" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <path id="Path_4685" data-name="Path 4685" d="M15,16.5v9" fill="none" stroke="#003645" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <path id="Path_4686" data-name="Path 4686" d="M21,16.5v9" fill="none" stroke="#003645" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                      </g>
                    </svg>
                  </span>
                </el-tooltip>
              </div>
            </div>
            <div :id="'defeciencyitem' + index" :class="!list.checked ? 'hide ' : ''" class=" absolute code top-0 left-0 bottom-0 right-0 opacity-50 green-background z2">
            </div>
          </div>
          <div class="flex col-12 my2">
          <button type="button" @click="sendforApproval(true)" v-if="lastUpdatedBy === 'company' || lastUpdatedBy === null" class="ml-auto px2 py1 rounted action-button"><span class="h5">SEND TIL GODKENDELSE</span></button>
          <button type="button" @click="sendforApproval(true)" class="ml-auto px2 py1 rounted action-button" v-else-if="lastUpdatedBy === 'contact' && !isPreApprove"><span class="h5">Godkend Liste</span></button>
          <!-- <button type="button" class="ml-auto px2 py1 rounted action-button" v-else-if="isFinalApprove"><span class="h5">Godkend Liste</span></button> -->
          </div>
          <div class="py4">
          </div>
        </div>
        <div v-else>
          <p class="h4 center semi-bold mt4">Ingen dato fundet</p>
        </div>
      </div>
    <b-modal v-model="incompleteModal" id="incompleteModal" no-close-on-esc no-close-on-backdrop centered hide-header hide-footer size="lg">
        <div class="col-12 flex justify-end items-center white-background px0 ">
          <button type="button" @click="closeincompleteModal()" class="white-button no-border not-rounded gibson ">
            <span> <i class="el-icon-circle-close"></i> </span>
          </button>
        </div> 
          <div class="incompleteItem lg-col-12 md-col-4 sm-col-6 xs-col-12 pr2 pb2">
            <div v-if="formLoading">
              <Loading></Loading>
            </div>
            <div class="px2 pt2 pb3" v-else>
              <el-form id="cvrfrom" :model="addItemForm" class="demo-form-inline tui-f md-col-10 lg-col-10 sm-col-12 mx-auto" :rules="addItemFormRules" ref="step4formcontact" label-position="top">
                <div class="clearfix mb2">
                  <el-form-item label="Title" prop="title" class="border-none el-form-opgavetype  p0 mr-auto" >
                    <el-input class="" placeholder="Input Title" v-model="addItemForm.title"></el-input>
                  </el-form-item>
                </div>
                <div class="clearfix mb2">
                  <el-form-item label="Industry" prop="branch" class="border-none el-form-opgavetype  p0 mr-auto" >
                    <el-select v-model="addItemForm.branch" multiple filterable :multiple-limit="1" placeholder="Tags" class="col-12 p0">
                      <el-option v-for="item in jobindustryBranch" :key="item.key" :label="item.label" :value="item.label"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="clearfix mb2">
                  <el-form-item label="Beskrivelse" prop="beskrivelse" class="border-none el-form-opgavetype  p0 mr-auto" >
                    <el-input class="mb1" type="textarea" placeholder="Add a short description" v-model="addItemForm.beskrivelse" :rows="5"></el-input>
                  </el-form-item>
                </div>
                <div class="flex justify-start items-start">
                </div>
                <div class="col-12 p0">
                  <el-upload action="#" ref="upload" class="mb2 col-12 p0" :auto-upload="false" :drag="true" :limit="5" :accept="acceptedFileType" :on-change="handleFileChange">
                      <i slot="default" class="el-icon-upload darkblue"></i>
                      <div class="el-upload__text center">Slip din fil her<span class="darkblue">Klik for at uploade</span></div>
                      <div class="el-upload__tip center darkblue">Filstørrelsesgrænse</div>
                      <div slot="file" slot-scope="{file}">
                        {{file.name}}
                        <button type="button" class="transparent-button" @click="removeImage(file, this.fileList)"><i class="el-icon-delete red"></i></button>
                      </div>
                  </el-upload> 
                </div>
                <div class="col-12 px0 mt3 flex justify-end">
                  <button class="action-button line-height-1 p2 test" @click.prevent="addDefiency()">
                    <span>Gemme</span>
                    <span class="ml1"><i class="el-icon-right"></i></span>
                  </button>
                </div>
              </el-form>
            </div>
          </div>
    </b-modal>
    <b-modal v-model="editincompleteModal" id="editincompleteModal" no-close-on-esc no-close-on-backdrop centered hide-header hide-footer size="lg">
        <div class="col-12 flex justify-end items-center white-background px0 ">
          <button type="button" @click="closeEditincompleteModal()" class="white-button no-border not-rounded gibson ">
            <span> <i class="el-icon-circle-close"></i> </span>
          </button>
        </div> 
          <div class="incompleteItem lg-col-12 md-col-4 sm-col-6 xs-col-12 pr2 pb2">
            <div v-if="formLoading">
              <Loading></Loading>
            </div>
            <div class="px2 pt2 pb3" v-else>
              <el-form id="cvrfrom" :model="addItemForm" class="demo-form-inline tui-f md-col-10 lg-col-10 sm-col-12 mx-auto" :rules="addItemFormRules" ref="step4formcontact" label-position="top">
                <div class="clearfix mb2">
                  <el-form-item label="Title" prop="title" class="border-none el-form-opgavetype  p0 mr-auto" >
                    <el-input class="" placeholder="Input Title" v-model="addItemForm.title"></el-input>
                  </el-form-item>
                </div>
                <div class="clearfix mb2">
                  <el-form-item label="Industry" prop="branch" class="border-none el-form-opgavetype  p0 mr-auto" >
                    <el-select v-model="addItemForm.branch" multiple filterable :multiple-limit="1" placeholder="Tags" class="col-12 p0">
                      <el-option v-for="item in jobindustryBranch" :key="item.key" :label="item.label" :value="item.label"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="clearfix mb2">
                  <el-form-item label="Beskrivelse" prop="beskrivelse" class="border-none el-form-opgavetype  p0 mr-auto" >
                    <el-input class="mb1" type="textarea" placeholder="Add a short description" v-model="addItemForm.beskrivelse" :rows="5"></el-input>
                  </el-form-item>
                </div>
                <div class="flex justify-start items-start">
                </div>
                <div class="col-12 p0">
                  <el-upload action="#" ref="upload" class="mb2 col-12 p0" :auto-upload="false" :drag="true" :limit="5" :accept="acceptedFileType" :on-change="handleFileChange">
                      <i slot="default" class="el-icon-upload darkblue"></i>
                      <div class="el-upload__text center">Slip din fil her<span class="darkblue">Klik for at uploade</span></div>
                      <div class="el-upload__tip center darkblue">Filstørrelsesgrænse</div>
                      <div slot="file" slot-scope="{file}">
                        {{file.name}}
                        <button type="button" class="transparent-button" @click="removeImage(file, this.fileList)"><i class="el-icon-delete red"></i></button>
                      </div>
                  </el-upload> 
                </div>
                <div class="col-12 p0">
                  <div v-for="imageitem in existingImages" :key="imageitem.ID">
                    <img :src="imageitem.IMAGE_LINK" width="80px" height="80px" class="rounded cover" alt="defiency images" />
                  </div>
                </div>
                <div class="col-12 px0 mt3 flex justify-end">
                  <button class="action-button line-height-1 p2 test" @click.prevent="addDefiency()">
                    <span>Gemme</span>
                    <span class="ml1"><i class="el-icon-right"></i></span>
                  </button>
                </div>
              </el-form>
            </div>
          </div>
    </b-modal>
    <b-modal v-model="viewCommentModal" id="viewCommentModal" centered hide-header hide-footer size="lg">
      <div class="col-12 flex justify-end items-center white-background px2 py1 ">
        <button type="button" @click="viewCommentModal = false" class="white-button no-border not-rounded gibson ">
          <span> <i class="el-icon-circle-close"></i> </span>
        </button>
      </div>
      <div v-if="commentloading">
        <Loading></Loading>
      </div>
      <div class="clearfix mb2" v-else>
        <p class="line-height-4 h3 darkblue mt1 semi-bold px3 m0">{{viewData.TITLE}}</p>
        <div class="flex flex-wrap gap-10 px3 my1">
            <b-img :src="imageItem.IMAGE_LINK" alt="Project Image" height="80px" v-for="imageItem in viewData.IMAGES" :key="imageItem" class="cover p0 covercover rounded" style="object-position: top;"></b-img>
        </div>
        <div class="border border-top-0 border-left-0 border-right-0 px3">
          <p class="line-height-golden h5 darkblue mt1 word-break pb2 regular p0 m0">{{viewData.DESCRIPTION}} asdaed sad ad wwdqe asd R er wqe wr qwer qe qeqwe qdqdqwedq wdqwdqwe  sda dasd asd asda da da d </p>
        </div>
        <div v-for="(items, index) in viewData.COMMENTS" :key="index" class="px3 my1">
          <div class="flex p0 mt2">
            <p class="h6 mb0 semi-bold">{{items.CREATED_BY.NAME}}</p>
            <p class="small lightgrey px2 m0 mb1"> {{ moment(items.DATE_CREATED).locale('da').format('LL') }}</p>
          </div>
          <p class="mb2 h6 darkblue line-height-golden">{{items.COMMENT}}</p>
        </div>
        <div class="px3 mt1">
          <el-input :autosize="{ minRows: 4, maxRows: 6 }" type="textarea" placeholder="Add comment" v-model="commentData"></el-input>
        </div>
        <div class="flex justify-end items-end px3">
          <button @click="saveComment(viewData.ID)" class="dark-button py1 px2 mt1 rounded">
            Tilføj kommentar
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal centered hide-footer hide-header id="gallerystagenew" class="m0 p0" width="100%" v-model="gallerystagenew" size="xl" ref="gallerystagenew">
      <div class="lg-col-8 md-col-10 xs-p0 xs-col-12 flex justify-between items-center p0 mx-auto absolute p2 z4">
        <button class="mr-auto p0 primary-white-button pointer close" @click="closengallery()">
          <i class="el-icon-back h1"></i>
        </button>
      </div>
      <div class="mx-auto" v-if="modalimageloading">
        <Loading></Loading>
      </div>
      <div class="flex flex-row justify-center col-12 m0 p0 height-full" v-else>
          <div class="p0 m0 col-10 mt4 pt3">
            <el-carousel :interval="4000" arrow="none" trigger="click" ref="galleryonenew" :setActiveItem="activestagephoto" :autoplay="false" :type="typegallery" id="galleryonenew" width="100%" indicator-position="outside">
              <el-carousel-item v-for="(item,index) in photos" :name="index.toString()" :key="index">
                <img id="imagedivreview" height="100%" class="cover pointer" :src="item.IMAGE_LINK" width="100%" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>
      </div>
    </b-modal>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import VueFormWizard from 'vue-form-wizard'
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'mangellist',
  components: {
    Simplert,
    VueFormWizard,
    ErrorHandler,
    Loading
  },
  computed: {
  },
  data: function () {
    return {
      loading: false,
      haaid: '',
      showMobile: false,
      salesPersonbitrix: '',
      pickerOptions: {
        disabledDate (time) {
          return (time.getTime() - (-86400000)) < Date.now()
        }
      },
      projectId: '',
      contractType: '',
      childprojects: [],
      partnerchildprojects: [],
      deadline: '',
      checked: false,
      incompleteModal: false,
      jobindustryBranch: [],
      itemsjobindustry: {},
      formLoading: false,
      commentloading: false,
      modalimageloading: false,
      addItemForm: {
        branch: [],
        title: '',
        beskrivelse: ''
      },
      addItemFormRules: {
        title: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit title',
          trigger: 'blur'
        }],
        beskrivelse: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit beskrivelse',
          trigger: 'blur'
        }],
        branch: [{
          type: 'array',
          required: true,
          message: 'Du bedes indtaste dit tag',
          trigger: 'change'
        }]
      },
      acceptedFileType: '.jpg,.png,.pdf,.pptx',
      images: [],
      fileList: [],
      getDefiencyList: [],
      isPreApprove: false,
      isFinalApprove: false,
      lastUpdatedBy: '',
      editincompleteModal: false,
      itemSelect: {},
      existingImages: [],
      viewCommentModal: false,
      viewData: [],
      commentData: '',
      activestagephoto: '0',
      gallerystagenew: false,
      typegallery: '',
      photos: []
    }
  },
  watch: {
  },
  created () {
    this.projectId = this.$route.query.projectId
    this.contractType = this.$route.query.contracttype
    this.childprojects = JSON.parse(this.$route.query.childprojects)
    this.childprojects.forEach(o => {
      if (o.IS_PARTNER) {
        this.partnerchildprojects.push(o.ID)
      }
    })
    this.gettaskbitrix()
    this.getDefiency(this.projectId)
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  methods: {
    checkimage (index) {
      // var image = 'https://haandvaerker.dk/uploads/00.webp'
      var image2 = 'https://photo.haandvaerker.dk/photos/minbolig/3130899/payment-stages-181-20220826060242JEG.webp'
      var getimage = document.getElementById('imagedivreview' + index)
      getimage.src = image2
    },
    closeincompleteModal () {
      this.incompleteModal = false
      this.addItemForm = {
        branch: [],
        title: '',
        description: ''
      }
    },
    markasdone (defeciencyid, index) {
      this.loading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/deficiency/' + defeciencyid + '/markAsDone', data, {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.addgreencover(index)
            this.getDefiency(this.projectId)
          }
          this.loading = false
        },
        (response) => {
          this.loading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    viewComment (listitemid) {
      this.viewData = []
      this.commentData = ''
      var viewArr = this.getDefiencyList.filter(resVal => {
        return listitemid === resVal.ID
      })[0]
      this.viewData = viewArr
      this.viewCommentModal = true
    },
    saveComment (listitemid) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      this.commentloading = true
      var headers = {
        Authorization: 'Bearer' + this.salesPersonbitrix
      }
      var data = {
        comment: this.commentData
      }
      this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/deficiency/' + listitemid + '/addComment', data, { headers }, {emulateJSON: true}).then(
        response => {
          var def = response.body.data.deficiency
          this.getDefiencyList = def
          this.viewComment(listitemid)
          this.commentloading = false
        },
        response => {
          this.commentloading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    opengallery (images, index = '', index2 = '') {
      this.currentstageindex = index + '-' + index2
      this.photos = []
      this.photos = images
      this.gallerystagenew = true
      this.typegallery = this.showMobile ? 'none' : 'card'
      setTimeout(() => {
        document.getElementById('gallerystagenew___BV_modal_body_').style.width = window.innerWidth + 'px'
        document.getElementById('sidebarphoto').style.height = parseInt(window.innerHeight - 150) + 'px'
        document.getElementById('gallerystagenew___BV_modal_body_').style.padding = 0 + 'px'
      }, 200)
    },
    addgreencover (index) {
      var defeciencyitem = document.getElementById('defeciencyitem' + index)
      defeciencyitem.classList.remove('hide')
    },
    openincompleteModal () {
      if (this.deadline === '') {
        this.$message({
          type: 'error',
          message: 'Indtast venligst en slutdato for alle varer på listen'
        })
        return false
      }
      this.incompleteModal = true
    },
    removeImage (file, fileList) {
      const index = fileList.indexOf(file)
      if (index > -1) {
        this.fileList.splice(index, 1)
      }
      const index2 = fileList.indexOf(file.raw)
      if (index2 > -1) {
        this.images.splice(index2, 1)
      }
    },
    handleFileChange (file, fileList) {
      const isLt1M = file.size / 1000 / 1000 < 7
      const isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp'
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 5 MB!'
        })
        let index = this.fileList.indexOf(file.key)
        this.fileList.splice(index, 1)
        return false
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        })
        let index = this.fileList.indexOf(file)
        this.fileList.splice(index, 1)
        return false
      }
      this.fileList = fileList.slice(0)
      this.images.push(file.raw)
    },
    getstageid (stageID) {
      this.selectedID = stageID
    },
    gettaskbitrix () {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.haaId = localStorage.getItem('haaid')
      this.$http.get(this.$bitrixapi + 'industries/full/', {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var industryname = {}
            this.jobindustryBranch = []
            res.data.forEach(l => {
              var industryBranch = {}
              industryBranch.key = l.BRANCHE_ID
              industryBranch.value = l.BRANCHE_ID
              industryBranch.label = l.BRANCHE
              this.jobindustryBranch.push(industryBranch)
              industryname[l.BRANCHE_ID] = l.BRANCHE
            })
            this.itemsjobindustry = industryname
          }
        },
        (response) => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    getDefiency (id) {
      this.loading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.$http.get(this.$bitrixapi + 'partner/project/' + id + '/deficiency', {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.isPreApprove = res.data.preApproved
            this.isFinalApprove = res.data.approved
            this.deadline = res.data.deficiency.length > 0 ? res.data.deficiency[0].END_DATE : ''
            this.lastUpdatedBy = res.data.lastUpdatedBy
            var updatedlist = []
            res.data.deficiency.forEach(l => {
              l.checked = false
              if (l.STATUS === 'done') {
                l.checked = true
              }
              updatedlist.push(l)
            })
            this.getDefiencyList = updatedlist
          }
          this.loading = false
        },
        (response) => {
          this.loading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    handleProgress (event, file, fileList) {
      console.log('event', event)
    },
    changeenddate () {
      this.$confirm('Ønsker du at ændre fristen, vil dette påvirke alle varer på listen?', {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(() => {
        this.formLoading = true
        this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {}
        this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/updateDeficiencyEndDate', data, { headers }, { emulateJSON: true }).then(
          response => {
            this.getDefiency(this.projectId)
          },
          response => {
            var error = response.body
            this.$message({
              type: 'error',
              message: error.message
            })
          })
      }).catch(() => {
      })
    },
    beforeFileUpload (file) {
      const isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp'
      const isLt1M = file.size / 1000 / 1000 < 17
      this.checkImageSizes()
      for (var i = 0; i < this.fileListTemp.length; i++) {
        if (this.fileListTemp[i].name === file.name) {
          this.$message({
            type: 'error',
            message: 'Kan ikke uploade det samme billede!'
          })
          return false
        }
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        })
        let index = this.fileList.indexOf(file)
        this.fileList.splice(index, 1)
        return false
      }
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 15 MB!'
        })
        let index = this.fileList.indexOf(file.key)
        this.fileList.splice(index, 1)
        return false
      }
      return isIMAGE && isLt1M
    },
    checkImageSizes () {
      var fileSize = 0
      for (var i = 0; i < this.fileList.length; i++) {
        fileSize = Number(fileSize) + Number(this.fileList[i].size)
      }
      if (fileSize > 17000000) {
        this.limitUpload = this.fileList.length
        // this.$message.error("Den samlede størrelse af billeder oversteg 30 MB.");
      } else {
        this.limitUpload = 50
      }
      this.totalImageSize = fileSize
    },
    addimage () {
      this.innerimageloading = true
      this.modalimageloading = true
      if (this.images.length > 5) {
        this.$message({
          type: 'error',
          message: 'Upload kun 5 filer til denne anmodning.'
        })
        return false
      }
      this.salesPerson = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      this.$http.post(this.$bitrixapi + 'partner/project/uploadPaymentStagePhotos?paymentStageId=' + this.selectedID, this.formData, { headers }, { emulateJSON: true }).then(
        response => {
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.innerimageloading = false
          this.selectedID = ''
          this.getstages()
        },
        response => {
          var error = response.body
          this.$message({
            type: 'error',
            message: error.message
          })
          this.selectedID = ''
        }
      )
    },
    addDefiency () {
      this.formLoading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var formData = new FormData()
      this.images.forEach(l => {
        formData.append('images[]', l)
      })
      formData.append('title', this.addItemForm.title)
      formData.append('industry', this.addItemForm.branch[0])
      formData.append('description', this.addItemForm.beskrivelse)
      formData.append('endDate', this.deadline)
      this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/deficiency', formData, { headers }, { emulateJSON: true }).then(
        response => {
          this.formLoading = false
          this.closeincompleteModal()
          this.getDefiency(this.projectId)
        },
        response => {
          var error = response.body
          this.$message({
            type: 'error',
            message: error.message
          })
        })
    },
    sendforApproval (boolean) {
      this.loading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        approve: boolean
      }
      this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/preApproveDeficiency', data, { headers }, { emulateJSON: true }).then(
        response => {
          let obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          this.getDefiency(this.projectId)
        },
        response => {
          var error = response.body
          this.$message({
            type: 'error',
            message: error.message
          })
        })
    },
    deleteDeficiency (deficiencyId) {
      this.$confirm('Hej, er du sikker på, at du vil slette dette element', {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(() => {
        this.formLoading = true
        this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {}
        this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/deficiency/' + deficiencyId, data, { headers }, { emulateJSON: true }).then(
          response => {
            this.formLoading = false
            this.getDefiency(this.projectId)
          },
          response => {
            var error = response.body
            this.$message({
              type: 'error',
              message: error.message
            })
          })
      }).catch(() => {
      })
    },
    openEditModal () {
      this.editincompleteModal = true
    },
    closeEditincompleteModal (item) {
      this.editincompleteModal = false
    },
    SelectDefiencyItem (item) {
      this.existingImages = []
      this.itemSelect = {}
      this.itemSelect = item
      this.addItemForm.title = item.TITLE
      this.addItemForm.branch.push(item.INDUSTRY)
      this.addItemForm.beskrivelse = item.DESCRIPTION
      this.existingImages = item.IMAGES
      this.openEditModal()
    },
    editDeficiency (deficiencyId) {
      this.formLoading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var formData = new FormData()
      this.images.forEach(l => {
        formData.append('images[]', l)
      })
      formData.append('title', this.addItemForm.title)
      formData.append('industry', this.addItemForm.branch[0])
      formData.append('description', this.addItemForm.beskrivelse)
      this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/deficiency/' + deficiencyId, formData, { headers }, { emulateJSON: true }).then(
        response => {
          this.formLoading = false
          this.getDefiency(this.projectId)
        },
        response => {
          var error = response.body
          this.$message({
            type: 'error',
            message: error.message
          })
        })
    },
    getcontractdetails () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.data) {
            this.currentContractData = res.data
          }
        },
        response => {
          var error = response.body.message
          this.$refs.errorMsg.showMsg(error)
        })
    },
    closengallery () {
      this.photos = []
      this.gallerystagenew = false
    },
    setactivestagephoto (index) {
      this.activestagephoto = index.toString()
      this.$refs.galleryonenew.setActiveItem(this.activestagephoto)
    },
    handleChange (event) {
      console.log('event', event)
    },
    getTermsCondition () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'helper/termsAndConditionsPopup', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.termsdata = res.filter(l => { return l.TYPE === 'Partner' })[0]
          this.termslink = this.termsdata.LINK
          this.termslabel = this.termsdata.LABEL
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    }
  }
}
</script>
<style>
#mangellist .gap-20 {
  gap:20px;
}
.gap-10 {
  gap:10px;
}
#incompleteModal .el-tag.el-tag--info {
  background-color: #003645;
  border-color: #003645;
  color: #ffff;
}
#mangellist .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4DCF55;
  border-color: #4DCF55;
}
#mangellist .el-checkbox__inner {
  width:30px;
  height: 30px;
  border: 1px solid #4DCF55;
}
#mangellist .el-checkbox__inner::after {
  height: 12px;
  left: 9px;
  position: absolute;
  top: 5px;
  width: 7px;
}
#incompleteModal .el-form-item__label {
  margin-bottom: 0em;
  padding: 0;
}
#incompleteModal .el-upload-dragger,.el-upload {
  width: 100%;
}
#mangellist .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #ffffff;
}
.tagitem {
  padding: 5px 10px 5px 10px;
  border-radius: 6px;
  background-color: gainsboro;
  display: flex;
  align-items: center;
  justify-content: center;
}
.font14 {
  font-size: 14px;
}
.font12 {
  font-size: 12px;
}
#viewCommentModal .modal-body {
  padding: 0;
}
#gallerystagenew .el-carousel__item--card.is-active {
  display: block;
}
#gallerystagenew .el-carousel__item {
  display: block;
}
#gallerystagenew .el-carousel__item--card {
  width: 65%;
}
#gallerystagenew .el-upload-list {
  display: none;
}
#gallerystagenew___BV_modal_content_ {
    height: 100%;
}
#gallerystagenew___BV_modal_content_ .el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
#gallerystagenew .modal-dialog {
  width: 100%;
  height: 100%;
  margin: 0px;
  margin-left: inherit;
}
#gallerystagenew .el-carousel__arrow {
  display: none;
}
#gallerystagenew .el-carousel__indicator {
  display: none;
}
#gallerystagenew___BV_modal_content_ .el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
#gallerystagenew___BV_modal_content_ {
  background: transparent!important;
}
#gallerystagenew___BV_modal_content_ .modal-content{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
#galleryonenew .el-carousel__container {
  height: 750px;
}
#gallerystagenew___BV_modal_body_  {
  margin-right: auto;
  margin-left: auto;
}
#gallerystagenew___BV_modal_content_ .el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
@media (max-width:27em) {
    .mobile-flex-column {
      flex-direction: column!important;
      align-items: center;
    }
    #mangellist .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 140px;
    }
    .xs-gap-10 {
      gap: 10px!important;
    }
    #mangellist .dark-button {
      height: 40px;
      width: 140px;
    }
    #galleryonenew .el-carousel__container {
      height: 345px;
    }
    #gallerystagenew .el-carousel__arrow {
      display: block!important;
    }
  }
</style>



// WEBPACK FOOTER //
// mangel-list.vue?1980cef4